import axiosInstance from '@/api/axiosInstance';

export const previewPurchase = async (data) => {
  const response = await axiosInstance.post('/users/me/purchase-intents/preview', data);
  return response.data;
};

export const createPaymentOrder = async (data) => {
  const response = await axiosInstance.post('/users/me/purchase-intents', data);
  return response.data;
};

export const getPurchaseIntentStatus = async (id) => {
  const response = await axiosInstance.get(`/users/me/purchase-intents/${id}`);
  return response.data;
};

export const getMyPurchases = async (params = {}) => {
  const response = await axiosInstance.get('/users/me/purchases', { params });
  return response.data;
};

export const confirmPurchaseReceipt = async (purchaseId) => {
  const response = await axiosInstance.post(`/users/me/purchases/${purchaseId}/shipment/receipt`);
  return response.data;
};

export const getPurchaseDetails = async (purchaseId) => {
  const response = await axiosInstance.get(`/users/me/purchases/${purchaseId}`);
  return response.data;
};